import React, { useState } from "react";
import { YoutubePlayerWithRemocon } from "components/YoutubePlayer";
import RemoteVideoController from "../components/RemoteVideoController";
import PauseClass from "../etcpage/PauseClass";
import { Checkbox } from "antd";
const YoutubeView = ({ url, onSendMessage, viewType }) => {
  const [data, setData] = useState({
    isStopAsyncMode: true,
    progress: 0,
    time: 0,
    volume: 80,
    mute: false,
    speed: 1,
    resolutions: [],
    autoResolution: true,
    currentResolution: null,
    resolutionName: null,
  });
  return (
    <div className="quetureview-layout">
      <>
        {viewType === "preview" ? (
          <div style={{ maxWidth: 1280 }}>
            <div className="playerWrap">
              <YoutubePlayerWithRemocon
                url={url}
                thumbnail={""}
                onEnded={() => {}}
                autoplay={false}
                earlyEndTriggerSeconds={0}
                viewType={viewType}
                // endTime={IS_LOCALHOST ? 10 : videoData?.endTime || 0}
                // pauseVideo={isOpinionPopupOpen || isSharePopupOpen}
              />
            </div>
          </div>
        ) : viewType === "guide" ? (
          <div>
            <Checkbox
              defaultChecked={true}
              checked={data.isStopAsyncMode}
              onChange={(e) => {
                setData({ isStopAsyncMode: e.target.checked });
              }}
            >
              동기화
            </Checkbox>
            <div style={{ maxWidth: 640 }}>
              <YoutubePlayerWithRemocon
                url={url}
                thumbnail={""}
                onEnded={() => {}}
                autoplay={false}
                earlyEndTriggerSeconds={0}
                onSendMessage={onSendMessage}
                viewType={viewType}
                isRemote={false}
                // endTime={IS_LOCALHOST ? 10 : videoData?.endTime || 0}
                // pauseVideo={isOpinionPopupOpen || isSharePopupOpen}
              />
            </div>
            <div>
              <RemoteVideoController
                isRemote={false}
                onSendMessage={onSendMessage}
              />
            </div>
          </div>
        ) : (
          <PauseClass />
        )}
      </>
    </div>
  );
};

export default YoutubeView;
